export default {
  grDate: 'GR Date',
  plants: 'Plant',
  latestValidationResult: 'Latest Validation Result',
  actualValidationResult: 'Actual Validation Result',
  cartonNumber: 'Carton Number',
  asnDn: 'ASN',
  asnDnSku: 'ASN SKU',
  specialSku: 'Special SKU',
  asnDnQty: 'ASN Qty',
  scanQty: 'Scanned Qty',
  deltaQty: 'Delta Qty',
  productName: 'Product Name',
  latestSystemValidationResult: 'Latest Validation Result',
  specialType: 'Special Type',
  exceptionType: 'Exception Type',
  sku: 'SKU',
  qty: 'Qty',
  accurate: 'Accurate',
  Unexpected: 'Unexpected',
  epcShortage: 'EPC Shortage',
  epcOverage: 'EPC Overage',
  upcMismatched: 'UPC Mismatched',
  manualConfirm: 'Manual Confirm',
  newCarton: 'New Carton',
  lastScannedDevice: 'Last Scanned Device Code',
  lastScanTime: 'Last Scan Time',
  misMatchedSku: 'Mismatched SKU',
  unknownSku: 'Unknown SKU',
  misMatchedQty: 'Mismatched Qty',
  validationResult: 'Validation Result',
  ttlCartonQty: 'TTL Carton Qty',
  mislabelingCartonQty: 'Mislabel CTN Qty',
  total: 'Total',
  opitionError: 'Carton Number, ASN, or GR Date must be filled in at least one of the three options!',
  cartonNumberMaxError: 'Carton Number allows a maximum of 50 input values is supported.',
  asnDnMaxError: 'ASN allows a maximum of 50 input values is supported.',
  cartonPe: 'Carton PE',
  // OB 报表专用，其余文案与 IB 共用
  obGrDate: 'GI Date',
  obAsnDn: 'Packlist',
  obAsnDnSku: 'GI SKU',
  obAsnDnQty: 'GI Qty',
  obOpitionError: 'Carton Number, Packlist, or GI Date must be filled in at least one of the three options!',
  obAsnDnMaxError: 'Packlist allows a maximum of 50 input values is supported.'
}
